exports.version = "1.8.0"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 452
// module chunks = 0